module.exports = __webpack_public_path__ + "img/LATAM_RED_MEATS.18f94147.png";